import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=15b2d826"
import script from "./DocumentList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentList.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports